import { useGlobal } from '@/utils/useGlobal';
import EFArrowRightUp from '@/components/UI/svg/Icons/EFArrowRightUp';

const linkDict: { [key: string]: string } = {
    us: 'https://account.ecoflow.com/agreement/en-us/EcoCredits-Rewards-Terms-Conditions.html',
    ca: 'https://account.ecoflow.com/agreement/en-ca/EcoCredits-Rewards-Terms-Conditions.html',
    au: 'https://account.ecoflow.com/agreement/en-au/EcoCredits-Rewards-Terms-Conditions.html',
    eu: 'https://account.ecoflow.com/agreement/en-eu/EcoCredits-Rewards-Terms-Conditions.html',
    uk: 'https://account.ecoflow.com/agreement/en-uk/EcoCredits-Rewards-Terms-Conditions.html',
    de: 'https://account.ecoflow.com/agreement/de-de/EcoCredits-Rewards-Terms-Conditions.html',
    fr: 'https://account.ecoflow.com/agreement/fr-fr/EcoCredits-Rewards-Terms-Conditions.html',
    it: 'https://account.ecoflow.com/agreement/it-it/EcoCredits-Rewards-Terms-Conditions.html',
    es: 'https://account.ecoflow.com/agreement/es-es/EcoCredits-Rewards-Terms-Conditions.html',
    jp: 'https://account.ecoflow.com/agreement/ja-jp/EcoCredits-Rewards-Terms-Conditions.html',
    kr: 'https://account.ecoflow.com/agreement/ko-kr/EcoCredits-Rewards-Terms-Conditions.html',
    za: 'https://account.ecoflow.com/agreement/en-za/EcoCredits-Rewards-Terms-Conditions.html',
};

const TnC = () => {
    const { Link, useRouter, useLang } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('ecocredits');

    const link = linkDict[locale || 'us'];

    return (
        <div className="t_c_content">
            <Link href={link}>
                <p className="t_c_text">
                    <span className="t">{t('see_t_c', { url: 'xxx' })}</span>
                    <span className="t_icon">
                        <EFArrowRightUp />
                    </span>
                </p>
            </Link>
        </div>
    );
};

export default TnC;
